import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { Button, Table } from 'react-bootstrap';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import EntityPropsUpdater from 'component/EntityPropsUpdater';
import List from 'components/List';

import Loader from 'components/layout/Loader';

import { getSystemTypeIcon } from 'helpers/cms';

class WhiteLabelPages extends EntityPropsUpdater {
  handleRowClick = cmsId => {
    this.props.history.push(
      this.props.appIntl.urlPrefix + 'account/settings/whiteLabel/' + this.props.entity.getId() + '/cms/' + cmsId
    );
  };

  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      list,
    } = this.props;

    const columns = [messages.name, messages.language, messages.actions];
    const tBody = [];
    for (let i = 0; i < list.data.list.length; i++) {
      const { id, name, language, system_type: systemType } = list.data.list[i];

      tBody.push(
        <tr key={i} class="clickable" onClick={() => this.handleRowClick(id)}>
          <td class="v-align-middle">
            {systemType ? <i class={'m-r-10 ' + getSystemTypeIcon(systemType)} /> : null}

            {name}
          </td>
          <td class="v-align-middle">{language}</td>
          <td class="v-align-middle text-right">
            <Button bsSize="sm" class="btn-rounded m-r-10">
              <i class="fa fa-pencil-alt" /> {messages.edit}
            </Button>
          </td>
        </tr>
      );
    }

    const resultTable = list.pending ? (
      <Loader />
    ) : (
      <Table responsive hover>
        <thead>
          <tr>
            {columns.map((column, i) => {
              return (
                <th key={i} class={column === messages.actions ? 'text-right' : ''}>
                  {column}
                </th>
              );
            })}
          </tr>
        </thead>
        <ReactCSSTransitionGroup
          transitionName="tablerows"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={1}
          component="tbody"
        >
          {tBody}
        </ReactCSSTransitionGroup>
      </Table>
    );

    return (
      <div class="clearfix padding-20 sm-padding-10">
        {entityLoaded ? (
          <div>
            <List
              listName="pages"
              url="/api/pages.json?showSystem=true&"
              urlData={{ filters: { whiteLabelProject: entity.getId() } }}
              list={list}
              noRender
            />

            {resultTable}
          </div>
        ) : null}
      </div>
    );
  }
}
WhiteLabelPages.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.pages,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(WhiteLabelPages)));
